import { render, staticRenderFns } from "./newsReport.vue?vue&type=template&id=7faf8378&scoped=true&"
import script from "./newsReport.vue?vue&type=script&lang=js&"
export * from "./newsReport.vue?vue&type=script&lang=js&"
import style0 from "./newsReport.vue?vue&type=style&index=0&id=7faf8378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf8378",
  null
  
)

export default component.exports